"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolGroupNotFoundError extends client_library_1.ExtendableError {
    constructor(schoolGroupId) {
        super(`School group not found: ${schoolGroupId}`);
        this.schoolGroupId = schoolGroupId;
    }
}
exports.default = SchoolGroupNotFoundError;
//# sourceMappingURL=SchoolGroupNotFoundError.js.map